'use client';

import { Image } from 'antd';
import { withFullPath } from '@/utils/utils';
import styles from './index.module.scss';
import useIsMobile from '@/hooks/useIsMobile';

type Props = {
    headerBanner: string;
    headerMobileBanner?: string;
};

const HeaderImg = (props: Props) => {
    const { windowSize } = useIsMobile();
    const isMobile = windowSize.width < 768;
    // console.log('HeaderImg-------', props);

    return isMobile ? (
        <>
            <Image
                preview={false}
                src={
                    !isMobile
                        ? withFullPath(props.headerBanner)
                        : withFullPath(props.headerMobileBanner)
                }
                alt=''
                width={'100%'}
            />
        </>
    ) : (
        <div
            className={`w-full min-h-[480px] ${styles.HeaderImg}`}
            style={{
                backgroundImage: `url(${withFullPath(props.headerBanner)})`,
            }}
        />
    );
};

export default HeaderImg;
